import React from 'react';
import { Play, Pause, SkipBack, SkipForward, Heart, Volume2, ListMusic, Download } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Slider } from './ui/slider';
import DownloadMenu from './DownloadMenu';

function fmt(s) {
  if (!s || isNaN(s)) return '0:00';
  const m = Math.floor(s/60); const r = Math.floor(s%60);
  return `${m}:${r.toString().padStart(2,'0')}`;
}

export default function Player() {
  const { lang, current, isPlaying, togglePlay, playNext, playPrev, progress, duration, seek, volume, setVolume, liked, toggleLike } = useApp();

  return (
    <div className="fixed left-0 right-0 bottom-0 z-40 border-t border-white/10 bg-[#0d0d0f]/95 backdrop-blur">
      <div className="flex items-center gap-4 px-3 lg:px-6 py-2.5">
        {/* Left: cover + title */}
        <div className="flex items-center gap-3 min-w-0 w-1/4">
          {current ? (
            <>
              <img src={current.cover} alt="" className="w-12 h-12 rounded-md object-cover" />
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">{current.title[lang] || current.title.en}</div>
                <div className="text-xs text-zinc-500 truncate">{current.artist}</div>
              </div>
              <button onClick={()=>toggleLike(current.id)} className={`ml-1 p-1.5 rounded hover:bg-white/10 ${liked.includes(current.id)?'text-pink-500':'text-zinc-400'}`}>
                <Heart size={16} fill={liked.includes(current.id)?'currentColor':'none'} />
              </button>
            </>
          ) : (
            <div className="text-xs text-zinc-500">{lang==='fr'?'Aucune piste sélectionnée':'No track selected'}</div>
          )}
        </div>

        {/* Center: controls */}
        <div className="flex-1 flex flex-col items-center gap-1">
          <div className="flex items-center gap-3">
            <button onClick={playPrev} className="p-2 text-zinc-300 hover:text-white"><SkipBack size={18} /></button>
            <button onClick={togglePlay} className="w-10 h-10 rounded-full bg-white text-black hover:scale-105 transition-transform flex items-center justify-center">
              {isPlaying ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
            </button>
            <button onClick={playNext} className="p-2 text-zinc-300 hover:text-white"><SkipForward size={18} /></button>
          </div>
          <div className="w-full max-w-xl flex items-center gap-2">
            <span className="text-[11px] text-zinc-500 tabular-nums w-9 text-right">{fmt(progress)}</span>
            <Slider
              value={[duration ? (progress/duration)*100 : 0]}
              onValueChange={(v)=> duration && seek((v[0]/100)*duration)}
              max={100}
              step={0.1}
              className="flex-1"
            />
            <span className="text-[11px] text-zinc-500 tabular-nums w-9">{fmt(duration)}</span>
          </div>
        </div>

        {/* Right: volume */}
        <div className="hidden md:flex items-center gap-2 w-1/4 justify-end">
          {current && (
            <DownloadMenu song={current} align="end" trigger={
              <button title="Download" className="p-2 text-zinc-400 hover:text-white"><Download size={16} /></button>
            } />
          )}
          <button className="p-2 text-zinc-400 hover:text-white"><ListMusic size={16} /></button>
          <Volume2 size={16} className="text-zinc-400" />
          <div className="w-24">
            <Slider value={[volume*100]} onValueChange={(v)=>setVolume(v[0]/100)} max={100} step={1} />
          </div>
        </div>
      </div>
    </div>
  );
}
